import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import Modal from "../Modal";
import "./style.scss";
import BodyText from "../../elements/body-text";
import Icon from "../../elements/icon";

export default function InfoModal({ fields = {}, showModal, setShowModal }) {
  const { body, headingBody, headingType, icon } = fields;
  return (
    <Modal
      className="info-modal"
      showModal={showModal}
      onCloseClicked={() => {
        setShowModal(false);
      }}
    >
      <div className="info-modal-heading">
        <Icon svg={icon?.svg?.value?.alt} size="m" />
        <Heading
          {...{
            type: headingType || { fields: { phrase: { value: "h2" } } },
            html: headingBody
          }}
          typographyClass="type-h1"
        />
      </div>

      <BodyText html={body?.value} />
    </Modal>
  );
}

InfoModal.propTypes = {
  fields: PropTypes.object
};
